import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faCheck } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';

import Tooltip from 'components/tooltip';

export function DealInboxEmailAddress({ inboxEmailAddress }) {
  const [copied, setCopied] = useState();

  if (!inboxEmailAddress) {
    return null;
  }

  function copy() {
    navigator.clipboard.writeText(inboxEmailAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <Tooltip content="Copy email address for this deal" dark>
      <FontAwesomeIcon
        className={classNames('text-muted clipboard-icon clickable', { 'text-success': copied })}
        icon={copied ? faCheck : faClipboard}
        onClick={copy}
      />
    </Tooltip>
  );
}

DealInboxEmailAddress.propTypes = {
  inboxEmailAddress: PropTypes.string,
};

const mapStateToProps = state => ({
  inboxEmailAddress: state.deal.inboxEmailAddress,
});

export default connect(mapStateToProps)(DealInboxEmailAddress);
